export const remoteControlMessages = {
  "remoteControl.title": "Remote Control",
  "remoteControl.description": "Continue your local CodeNomad sessions from another device without opening network ports.",
  "remoteControl.refresh": "Refresh",
  "remoteControl.state.stopped": "Remote Control is off",
  "remoteControl.state.connecting": "Connecting to the relay…",
  "remoteControl.state.connected": "Ready for remote connections",
  "remoteControl.state.reconnecting": "Reconnecting…",
  "remoteControl.state.error": "Relay connection failed",
  "remoteControl.status.localOnly": "CodeNomad is available on this device only.",
  "remoteControl.status.hostOnly": "Manage Remote Control from the CodeNomad host.",
  "remoteControl.start": "Start Remote Control",
  "remoteControl.newLink": "Create new pairing link",
  "remoteControl.stop": "Stop Remote Control",
  "remoteControl.pairing.title": "Connect another device",
  "remoteControl.pairing.description": "Scan this QR code or open the one-time link on your other device.",
  "remoteControl.pairing.qrAlt": "Remote Control pairing QR code",
  "remoteControl.pairing.copy": "Copy link",
  "remoteControl.pairing.copied": "Copied",
  "remoteControl.pairing.expires": "This link expires at {time}.",
  "remoteControl.devices.title": "Paired devices",
  "remoteControl.devices.description": "These devices can access this CodeNomad host while Remote Control is running.",
  "remoteControl.devices.empty": "No devices are paired yet.",
  "remoteControl.devices.lastSeen": "Last seen {time}",
  "remoteControl.devices.revoke": "Revoke",
} as const
